import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const TOGGLE_MANAGER_DIALOG = 'sherrinford/manager/TOGGLE_MANAGER_DIALOG'

const GET_MANAGER_SUGGESTIONS_REQUEST = 'MANAGER/GET_MANAGER_SUGGESTIONS_REQUEST'
const GET_MANAGER_SUGGESTIONS_SUCCESS = 'MANAGER/GET_MANAGER_SUGGESTIONS_SUCCESS'
const GET_MANAGER_SUGGESTIONS_ERROR = 'MANAGER/GET_MANAGER_SUGGESTIONS_ERROR'

const RESET_MANAGER_SUGGESTIONS = 'MANAGER/RESET_MANAGER_SUGGESTIONS'

const SET_SELECTED_MANAGER = 'MANAGER/SET_SELECTED_MANAGER'

const POST_SELECTED_MANAGER_REQUEST = 'MANAGER/POST_SELECTED_MANAGER_REQUEST'
const POST_SELECTED_MANAGER_SUCCESS = 'MANAGER/POST_SELECTED_MANAGER_SUCCESS'
const POST_SELECTED_MANAGER_ERROR = 'MANAGER/POST_SELECTED_MANAGER_ERROR'

const initialStates = {
  isLoading: false,
  isManagerDialogOpen: false,
  suggestedManagers: [],
  selectedManager: null,
}

export default createReducer(initialStates, {
  [TOGGLE_MANAGER_DIALOG]: (state, payload) => ({
    ...state,
    isManagerDialogOpen: payload,
  }),

  // Get suggestions
  [GET_MANAGER_SUGGESTIONS_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_MANAGER_SUGGESTIONS_SUCCESS]: (state, res) => ({
    ...state,
    suggestedManagers: res.rows || [],
    isLoading: false,
  }),
  [GET_MANAGER_SUGGESTIONS_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  // Reset suggestions
  [RESET_MANAGER_SUGGESTIONS]: state => ({
    ...state,
    suggestedManagers: [],
  }),

  // Set selected manager
  [SET_SELECTED_MANAGER]: (state, profileId) => ({
    ...state,
    selectedManager: profileId,
  }),

  // Post selected manager to backend
  [POST_SELECTED_MANAGER_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_SELECTED_MANAGER_SUCCESS]: state => ({
    ...state,
    isManagerDialogOpen: false,
    isLoading: false,
  }),
  [POST_SELECTED_MANAGER_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const toggleManagerDialog = isOpen => ({
  type: [TOGGLE_MANAGER_DIALOG],
  payload: isOpen,
})

export const getManagerSuggestions = (value, skip = 0, limit = 50, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_MANAGER_SUGGESTIONS_REQUEST,
      GET_MANAGER_SUGGESTIONS_SUCCESS,
      GET_MANAGER_SUGGESTIONS_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile/profiles?value=${value}&limit=${limit}&skip=${skip}`,
      authorization: token,
      universeHost: true,
    },
    nextAction: res => cb(res),
  }
}

export const resetManagerSuggestions = () => ({
  type: [RESET_MANAGER_SUGGESTIONS],
})

export const setSelectedManager = profileId => {
  return {
    type: [SET_SELECTED_MANAGER],
    payload: profileId,
  }
}

export const postSelectedManager = () => {
  const token = JSON.parse(isAuthorized())
  return (dispatch, getState) => {
    const { Manager, ProjectDetail } = getState()

    const orderId = ProjectDetail.data.id
    const payloads = {
      manager: Manager.selectedManager.id,
      managedPercentageFee: 30,
    }

    return dispatch({
      type: [
        POST_SELECTED_MANAGER_REQUEST,
        POST_SELECTED_MANAGER_SUCCESS,
        POST_SELECTED_MANAGER_ERROR,
      ],
      shuttle: {
        method: 'POST',
        path: `/ps/order/${orderId}/manage`,
        payloads,
        authorization: token,
        universeHost: true,
      },
      nextAction: () => {
        window.location.reload()
      },
    })
  }
}
